const personalController = "personal";
const verificationController = "v1/verification";
const documentController = "/document";
const usersController = "users";
const bookingsController = "productbookings";
const disputesController = "dispute";
const authController = "auth";
const paymentsController = "transactions/admin";
const reviewsController = "reviews";
const dashboardController = "dashboard";
const Lookup = "lookup";
const transactionsController = "transactions";
const chatController = "chats";
const notificationsController = "notification"; 

export const API_CONFIG_URLS = {
  AUTH: {
    ME: `${personalController}/profile`,
    LOGIN: `${authController}/login`,
    LOGOUT: `${usersController}/logout`,
    RESEND_OTP: `${usersController}/forgot-password`,
    FORGOT_PASSWORD: `${usersController}/forgot-password`,
    RESET_PASSWORD: `${usersController}/reset-password`,
    VERIFY_FORGOT_OTP: `${usersController}/verify-password-otp`,
    CHANGE_PASSWORD: `${personalController}/change-password`,
  },
  DASHBOARD: {
    GET_DASHBOARD_STATS: `/v1/${dashboardController}/dashboard/statistics`,
    GET_DASHBOARD_REVENUE_GRAPH: `/v1/${dashboardController}/revenue/graph`,
    GET_DASHBOARD_USER_ACTIVITY_GRAPH: `/v1/${dashboardController}/user-activity/graph`,
    GET_DASHBOARD_RECENT_BOOKINGS: `/v1/${dashboardController}/admin/booking`,
    GET_DASHBOARD_RECENT_DISPUTES: `/v1/${dashboardController}/admin/disputes`,
    GET_DASHBOARD_PAYMENT_OVERVIEW: `/v1/${dashboardController}/payment/overview`,
  },
  USERS: {
    GET_USERS_LIST: `${usersController}/user-list`,
    GET_USERS_STATS: `${usersController}/user-stats`,
    DELETE_USER: `${usersController}/delete-user`,
    GET_USER_DETAILS: `${usersController}`,
    UPDATE_USER_STATUS: `${usersController}/update-account-status`,
    ADMIN_DELETION_IMPACT: `${usersController}/admin`,
    ADMIN_DELETE_USER: `${usersController}/admin/delete-user`,
    ADMIN_RESTORE_USER: `${usersController}/admin/restore-user`,
    ADMIN_EDIT_USER: `${usersController}/admin`,
  },
  BOOKINGS: {
    GET_BOOKINGS_LIST: `/v1/${bookingsController}/admin/list`,
    GET_BOOKING_DETAILS: `/v1/${bookingsController}`,
    GET_BOOKING_STATS: `/v1/${bookingsController}/statistics`,
    DELETE_BOOKING: `/v1/${bookingsController}`,
  },
  DISPUTES: {
    GET_DISPUTE_LIST: `/v1/${disputesController}/dispute/admin/list`,
    GET_DISPUTE_DETAILS: `/v1/${disputesController}/dispute/admin/details`,
    GET_DISPUTE_STATS: `/v1/${disputesController}/dispute/admin/stats`,
    ADD_INTERNAL_CASE_NOTE: `/v1/${disputesController}`,
    PROCESS_FULL_REFUND: `/v1/${disputesController}`,
    PROCESS_PARTIAL_REFUND: `/v1/${disputesController}`,
    GET_RESOLUTION_SUMMARY: `/v1/${disputesController}`,
    POST_RESOLUTION_SUMMARY: `/v1/${disputesController}`,
  },
  PAYMENTS: {
    GET_PAYMENTS_LIST: `/v1/${paymentsController}/withdrawals/list`,
    GET_PAYMENT_DETAILS: `/v1/${paymentsController}/withdrawals/details`,
    GET_PAYMENT_STATS: `/v1/${paymentsController}/summary`,
    PAYMENT_ACTION: (withdrawalId) =>
      `/v1/${paymentsController}/withdrawals/${withdrawalId}/action`,
    TRANSACTION_HISTORY: `/v1/${paymentsController}/withdrawals/history`,
  },
  REVIEWS: {
    GET_REVIEWS_LISTINGS: `/v1/${reviewsController}`,
    GET_REVIEWS_LIST: `/v1/${reviewsController}/admin/review/list`,
    GET_REVIEW_STATS: `/v1/${reviewsController}/admin/review/stats`,
    REMOVE_REVIEW: `/v1/${reviewsController}`,
    HIDE_REVIEW: `/v1/${reviewsController}/{reviewId}`,
  },
  PROFILE: {
    CHANGE_PASSWORD: `${personalController}/change-password`,
    EDIT_PROFILE: `${personalController}/profile`,
  },
  DOCUMENTS: {
    UPLOAD_DOCUMENTS: `${documentController}`,
    DOWNLOAD_IMAGE: `${documentController}/fetch`,
  },
  LOOKUP: {
    GET_CITIES: `/${Lookup}/admin/location`,
    GET_CATEGORIES: `/${Lookup}/categories`,
    GET_ALL_USERS: `/${Lookup}/admin/users`,
  },
  CHATS: {
    GET_DISPUTE_CHAT: `/${chatController}`,
  },
  TRANSACTIONS: {
    GET_TRANSACTION_LISTING: `/v1/${transactionsController}/admin/list`,
  },
  NOTIFICATIONS: {
    GET_NOTIFICATION_LISTINGS: `/${notificationsController}`,
    MARK_ALL_AS_READ: `/${notificationsController}/mark`,
    NOTIFICATION_COUNT: `/${notificationsController}/count`
  },
  VERIFICATION: {
    GET_LIST: `/${verificationController}/admin/list`,
    GET_STATS: `/${verificationController}/admin/stats`,
    GET_DETAIL: `/${verificationController}/admin`,
    GET_DETAIL_BY_USER: `/${verificationController}/admin/by-user`,
    APPROVE: `/${verificationController}/admin`,
    REJECT: `/${verificationController}/admin`,
    UNBLOCK: `/${verificationController}/admin`,
    GRANT_ATTEMPTS: `/${verificationController}/admin`,
  },
  PRODUCT_REQUESTS: {
    GET_LIST: `/v1/productrequests/admin/list`,
    GET_DETAILS: `/v1/productrequests/admin`,
    GET_USED_CATEGORIES: `/v1/productrequests/admin/categories`,
  },
};

export const multiFormDataHeader = {
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "text/plain",
  },
};

export const jsonFormatDataHeader = "application/json";
